import { Route } from "react-router-dom";
import PortalGuard from "../components/PortalGuard";
import ShopLayout from "../layouts/ShopLayout";
import {
  ShopOverview, ShopEvents, ShopOpenPlay, ShopTournaments,
  ShopAttendees, ShopProfile, ShopBadges, ShopManagers,
  ShopInsights, ShopPlan, ShopCommunity
} from "../pages/shop/ShopPortalViews";
import { ShopGameLibrary, ShopAvailableTonight } from "../pages/shop/ShopGameLibraryViews";
import { ShopQuickCreate, ShopRSVPDashboard, ShopTournamentOps } from "../pages/shop/ShopOpsViews";
import { ShopRulePackManager } from "../pages/shop/ShopRulePackViews";
import { ShopSocialHub } from "../pages/shop/ShopSocialHub";

export function ShopRoutes({ ProtectedRoute }) {
  return (
    <Route
      path="/shop/:shopId"
      element={<ProtectedRoute><PortalGuard portal="shop_portal"><ShopLayout /></PortalGuard></ProtectedRoute>}
    >
      <Route index element={<ShopOverview />} />
      <Route path="quick-create" element={<ShopQuickCreate />} />
      <Route path="rsvp-dashboard" element={<ShopRSVPDashboard />} />
      <Route path="tournament-ops" element={<ShopTournamentOps />} />
      <Route path="tournament-ops/:tournamentId" element={<ShopTournamentOps />} />
      <Route path="events" element={<ShopEvents />} />
      <Route path="open-play" element={<ShopOpenPlay />} />
      <Route path="tournaments" element={<ShopTournaments />} />
      <Route path="attendees" element={<ShopAttendees />} />
      <Route path="profile" element={<ShopProfile />} />
      <Route path="badges" element={<ShopBadges />} />
      <Route path="managers" element={<ShopManagers />} />
      <Route path="insights" element={<ShopInsights />} />
      <Route path="community" element={<ShopCommunity />} />
      <Route path="game-library" element={<ShopGameLibrary />} />
      <Route path="available-tonight" element={<ShopAvailableTonight />} />
      <Route path="rule-packs" element={<ShopRulePackManager />} />
      <Route path="social-hub" element={<ShopSocialHub />} />
      <Route path="plan" element={<ShopPlan />} />
    </Route>
  );
}
